export default "__VITE_ASSET__901abf47__"